(function (angular) {
    'use strict';

    angular.module('templates')

        .controller("chatTemplatesModal", ["$uibModalInstance", "templatesData", "conversationChannel", "sharedDataService", '$anchorScroll', '$location',
            function ($uibModalInstance, templatesData, conversationChannel, sharedDataService, $anchorScroll, $location) {

                var vm = this;
                vm.templates = templatesData;
                vm.conversationChannel = conversationChannel;
                var contentTypeLimits = sharedDataService.getChannelContentTypeLimits(vm.conversationChannel);

                vm.cancel = function () {
                    $uibModalInstance.dismiss();
                }

                vm.filterByContentTypeLimits = function () {
                    if (contentTypeLimits) {

                        vm.filteredTemplates = vm.templates.filter(function (obj) {
                            var validateMessage = true;
                            var contentTypeLimitsCopy = angular.copy(contentTypeLimits);
                            for (var element of obj.messageParts) {
                                //checking if type is supported by channel
                                if (!sharedDataService.checkIfTypeSupported(element.type, vm.conversationChannel)) {
                                    validateMessage = false;
                                    break;
                                }
                                var elType = element.type.split('/')[0];
                                for (var el in contentTypeLimitsCopy) { // checking different limits combinations for every messagePart
                                    var object = contentTypeLimitsCopy[el];
                                    for (var type in object) {
                                        if (type === elType) { //if messagePart type is the same as name of combination, we want to decrease this type limits in every combination 
                                            object[type] -= 1;
                                        } // at the same time we want to check if that combination is invalid (any type is < 0), if so - we're removing the template from the list to display
                                        if (object[type] < 0 && object[el] !== contentTypeLimits[el][el]) {
                                            validateMessage = false;
                                            break;
                                        }
                                    }
                                }
                            };
                            return validateMessage;
                        });
                    }
                    if (vm.filteredTemplates.length === 1) {
                        vm.picked.template = vm.filteredTemplates[0];
                    }
                }
                vm.picked = {};
                vm.currentIndex;
                vm.filterByContentTypeLimits();

                vm.onChange = function () {
                    vm.currentIndex = 0;
                    delete vm.picked.template;
                }

                vm.goTo = function (index) {
                    $location.hash('number' + index);
                    $anchorScroll();
                }

                vm.keyDown = function (event) {
                    //down-arrow
                    if (event.keyCode == 40) {
                        if (!vm.picked.template || vm.currentIndex == vm.items.length - 1) {
                            vm.currentIndex = 0;
                            vm.picked.template = vm.items[vm.currentIndex];
                            vm.goTo(vm.currentIndex);
                        }
                        else {
                            vm.currentIndex++;
                            vm.picked.template = vm.items[vm.currentIndex];
                            vm.goTo(vm.currentIndex);
                        }
                    }
                    //up-arrow
                    else if (event.keyCode == 38) {
                        if (!vm.picked.template || vm.currentIndex == 0) {
                            vm.currentIndex = vm.items.length - 1;
                            vm.picked.template = vm.items[vm.currentIndex];
                            vm.goTo(vm.currentIndex);
                        }
                        else {
                            vm.currentIndex--;
                            vm.picked.template = vm.items[vm.currentIndex];
                            vm.goTo(vm.currentIndex);
                        }
                    }
                    //enter -> send 
                    else if (event.keyCode == 13) {
                        if (vm.picked.template) {
                            vm.sendTemplate(vm.picked.template);
                        }
                    }
                    //escape -> close modal
                    else if (event.keyCode == 27) {
                        vm.cancel();
                    }
                }

                vm.stopEvent = function (event) {
                    var keyPress = event.keyCode;
                    if (keyPress == 40 || keyPress == 38 || keyPress == 27) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };

                vm.sendTemplate = function (template) {
                    $uibModalInstance.close(template);
                }

                vm.search = {};
                vm.filter = (template) => {

                    if ((!vm.search.keyWords) ||
                        (vm.search.keyWords && ((template.name + ' ' + template.description).toLowerCase().includes(vm.search.keyWords.toLowerCase())))) {
                        return true;
                    }
                    return false;
                }
                vm.pickTemplate = function (template, index) {
                    vm.picked.template = template;
                    vm.currentIndex = index;
                }
            }])

})(window.angular);
